export default "__VITE_ASSET__DEwuAPfR__"